/* eslint-disable complexity */
import {useCallback} from 'react';
import styles from './index.module.scss';
import Menu, {MenuItem, MenuItemId} from '@/components/Menu';
import Avatar, {AvatarSize} from '@/components/Avatar';
import Text, {TextType, TextColor} from '@/components/Text';
import classNames from 'classnames';
import ExternalLabel from '@/components/ExternalLabel';

interface IProps {
    data: Repository[];
    className?: string;
    searchVal?: string;
    onSelectRepository: (repositoryInfo: MenuItemId) => void;
    checkedRepo: string;
    operationType: number;
}

export default function MenuList(props: IProps) {
    const {
        data = [],
        className = '',
        searchVal = '',
        onSelectRepository,
        checkedRepo = '',
        operationType = 0,
    } = props;

    const searchLight = useCallback((content: string) => {
        if (!content) {
            return null;
        }
        const reg = new RegExp(searchVal, 'i');
        const title = content.replace(reg, value => {
            return `<em>${value}</em>`;
        });
        return (
            // eslint-disable-next-line react/no-danger
            <span dangerouslySetInnerHTML={{__html: title}}></span>
        );
    }, [searchVal]);

    return (
        <Menu
            layout="vertical"
            onSelect={onSelectRepository}
            className={classNames(styles.menu, className)}
        >
            {data.map((repository: any) => {
                const isActive = !!(checkedRepo &&
                            (JSON.parse(checkedRepo).repositoryGuid === repository.repositoryGuid));
                return (
                    <MenuItem
                        key={repository.repositoryGuid}
                        id={
                            JSON.stringify({
                                groupGuid: repository.groupGuid,
                                repositoryGuid: repository.repositoryGuid,
                                spaceGuid: repository.spaceGuid,
                                name: repository.name,
                                operationType: operationType,
                                roleName: repository.roleName || '',
                                ownerType: repository.ownerType,
                                userGuid: repository.userGuid || '',
                            })
                        }
                        className={`${styles.menuItem} ${isActive ? styles.menuItemActive : null}`}
                    >
                        <Avatar
                            spaceGuid={repository.spaceGuid}
                            groupGuid={repository.groupGuid}
                            repositoryGuid={repository.repositoryGuid}
                            size={AvatarSize.XS}
                            className={styles.avatar}
                        />
                        <Text
                            type={TextType.T14}
                            color={TextColor.Dark}
                            className={`${styles.name} ${isActive ? styles.textActive : null}`}
                            title={repository.name}
                        >
                            {searchVal
                                ?
                                (searchLight(repository.name))
                                :
                                repository.name}
                        </Text>
                        {
                            repository?.external
                                ? <ExternalLabel labelName={'外部'} className={styles.externalLab} />
                                : null
                        }
                    </MenuItem>
                );
            })}
        </Menu>
    );
}
